import { FC } from 'react';

import useGlobalNotice from 'src/hooks/useGlobalNotice';

import classes from './GlobalNoticeBanner.module.scss';

/**
 * Firestore `config/commerce`의 `globalNotice`(전역 공지)를 화면 상단에 노출하는 배너.
 *
 * - 표시 여부/메시지/스타일(variant)/닫기 가능 여부는 모두 Firestore 문서로 제어된다.
 * - 상시 운영 배너인 `notice`와는 별개 필드/표시 위치/수명주기다.
 * - 노출·"다시 보지 않기" 로직은 {@link useGlobalNotice} 참고.
 */
const GlobalNoticeBanner: FC = () => {
  const { globalNotice, visible, dismiss } = useGlobalNotice();

  if (!visible || !globalNotice) {
    return null;
  }

  const variant = globalNotice.variant ?? 'info';
  const dismissible = globalNotice.dismissible ?? true;

  return (
    <div className={`${classes.banner} ${classes[variant]}`} role={variant === 'warning' ? 'alert' : 'status'}>
      <span className={classes.message}>{globalNotice.message}</span>
      {dismissible && (
        <button type='button' className={classes.closeButton} aria-label='공지 닫기' onClick={dismiss}>
          ×
        </button>
      )}
    </div>
  );
};

export default GlobalNoticeBanner;
